import { get, post } from 'utils/rxfetch'

const SNAPSHOT_URL = '/members-api/credit-management/notifications'
const DISMISS_POPUP_URL = '/members-api/credit-management/notifications/dismiss-popup'

const plgNotificationsAPI = {
  // First-paint / reconnect snapshot — REST catch-up for the no-offline-queue
  // Socket.IO layer. Returns { bell, popup, reset_date_label }; bell/popup are
  // null when nothing is pending, and reset_date_label is served to every
  // authenticated user. `popup` is the toast channel:
  //   credits_requested → admin credit-request toast
  //   credits_restored  → restored-credits toast (all users; login catch-up)
  getSnapshot() {
    return get(SNAPSHOT_URL)
  },
  // Advances the per-session popup dismiss cursor.
  //   dismissPopup(throughId)              → credits_requested (legacy)
  //   dismissPopup({ type, through_id? })   → credits_requested | credits_restored
  dismissPopup(throughIdOrBody) {
    if (
      throughIdOrBody != null &&
      typeof throughIdOrBody === 'object' &&
      !Array.isArray(throughIdOrBody)
    ) {
      return post(DISMISS_POPUP_URL, throughIdOrBody)
    }
    return post(DISMISS_POPUP_URL, { through_id: throughIdOrBody })
  },
}

export default plgNotificationsAPI
